var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { VALIDATE_DATE_IDS } from '../../../const/questionIds';
import { addBusinessDays, addDays, isAfter, isBefore, isValid, isWithinInterval } from 'date-fns';
import getCurrentQuestionAnswer from '../../../helpers/getCurrentQuestionAnswer';
import parseCalendarDates from '../../../helpers/parseCalendarDates';
import useCalendarBlur from '../../../hooks/useCalendarBlur';
import { focusRef, formatAndDispatchDateAnswer, setDateToAnswer } from '../../../pages/Questionnaire/subcomponents/Question/helpers';
import { useEffect, useRef, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { clearFormError, updateFormError } from '../../../redux/ui/ui.slice';
import { updateUserAnswers } from '../../../redux/userAnswers/userAnswers.slice';
import { t } from '../../../strings/i18n/i18n';
import AdditionalContent from '../AdditionalContent';
import Calendar from '../Calendar';
var CalendarQuestion = function (_a) {
    var _b, _c;
    var answer = _a.answer;
    var dispatch = useDispatch();
    var _d = useSelector(function (state) { return state; }, shallowEqual), _e = _d.ui, formError = _e.formError, additionalFieldFormError = _e.additionalFieldFormError, userAnswers = _d.userAnswers, currentQuestion = _d.questionnaire.currentQuestion;
    var calendarRef = useRef(null);
    var textfieldRef = useRef(null);
    var _f = useState(null), selectedDate = _f[0], setSelectedDate = _f[1];
    var options = (answer === null || answer === void 0 ? void 0 : answer.answerOptions) || [];
    var hasAdditionalContent = (_b = options[0]) === null || _b === void 0 ? void 0 : _b.additionalContent;
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var _g = parseCalendarDates({
        startDate: answer.startDate,
        endDate: answer.endDate,
        excludedDates: answer.excludedDates
    }), startDate = _g.startDate, endDate = _g.endDate, excludedDates = _g.excludedDates;
    var validateDate = function (date) {
        if (!isValid(date)) {
            dispatch(updateFormError(t('calendar.validDate')));
            return false;
        }
        // Target special scenario for the questions that have date constraints
        if (!VALIDATE_DATE_IDS.includes(currentQuestion.id)) {
            return true;
        }
        var today = new Date();
        var isWithinSevenBusinessDays = isWithinInterval(date, {
            start: addBusinessDays(today, -7),
            end: today
        });
        // selected date cannot be within the current week (need to give merchant 7 days to process return)
        if (isWithinSevenBusinessDays) {
            dispatch(updateFormError(t('calendar.greaterThanSevenDays')));
            return false;
        }
        var oneHundredEightyDaysBeforeToday = addDays(today, -180);
        // selected date cannot be 180 days in the past (need to raise dispute through online chat)
        if (isBefore(date, oneHundredEightyDaysBeforeToday)) {
            dispatch(updateFormError(t('calendar.dateBeyond180Days')));
            return false;
        }
        if (isAfter(date, today)) {
            dispatch(updateFormError(t('calendar.dateBeyond180Days')));
            return false;
        }
        return true;
    };
    var handleChange = function (date) {
        if (!validateDate(date)) {
            setSelectedDate(date);
            return;
        }
        var currentDate = date;
        if (currentDate < startDate) {
            currentDate = startDate;
        }
        else if (currentDate > endDate) {
            currentDate = endDate;
        }
        setSelectedDate(currentDate);
        dispatch(clearFormError());
        var payload = formatAndDispatchDateAnswer(currentDate, currentQuestionAnswer, options, currentQuestion);
        dispatch(updateUserAnswers(payload));
    };
    var _h = useCalendarBlur(handleChange), handleBlur = _h.handleBlur, handleMouseEnter = _h.handleMouseEnter, handleMouseLeave = _h.handleMouseLeave;
    useEffect(function () {
        var _a;
        setDateToAnswer((_a = currentQuestionAnswer === null || currentQuestionAnswer === void 0 ? void 0 : currentQuestionAnswer.answers) === null || _a === void 0 ? void 0 : _a[0], function () {
            setSelectedDate(new Date(currentQuestionAnswer.answers[0]));
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var error = additionalFieldFormError || formError;
        var formRef = additionalFieldFormError ? textfieldRef : calendarRef;
        focusRef(formRef, error);
    }, [formError, additionalFieldFormError]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ ref: calendarRef, tabIndex: -1, "data-cy": "calendar-field", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave }, { children: _jsx(Calendar, { startDate: startDate, error: formError, endDate: endDate, excludedDates: excludedDates, id: "calendar-question", selectedDate: selectedDate, onChange: handleChange, onBlur: handleBlur, placeholderLabel: "".concat(t('calendar.placeholder')), required: true }) })), hasAdditionalContent && currentQuestionAnswer && (_jsx(AdditionalContent, { answerMetadata: (_c = options[0]) === null || _c === void 0 ? void 0 : _c.metadata, textfieldRef: textfieldRef }))] }));
};
export default CalendarQuestion;
//# sourceMappingURL=index.js.map